import {GameBase} from "./GameBase";
import {SoundEffect} from "../common/SoundEffect";
import {Point} from "../Point";
import {RecordManager} from "../common/RecordManager";
import {DumbbellCurlDetector} from "../detector/DumbbellCurlDetector";

export class DumbbellCurl extends GameBase {
  constructor() {
    super()
    this.score = 0
    this.fistType = null

    // for thumb
    // this.handMode = true

    const onInit = () => {
      this.se2.play()
    }
    const onDetect = () => {
      this.se1.play()
      this.score++
      this.saveData()
    }
    this.detector = new DumbbellCurlDetector(onInit, onDetect)
    this.initSound()

    this.started = false
  }

  changeSettings(key, value) {
    super.changeSettings(key, value)
    this.detector[key] = value
  }

  initSound() {
    this.startSE = new SoundEffect("start")
    this.se1 = new SoundEffect("don")
    this.se2 = new SoundEffect("kaka")
  }

  mainLoop({ pose, hands }) {
    if (!pose || !pose[0]) return

    const points2D = pose[0].keypoints
    const points = pose[0].keypoints3D
    this.navigations = []
    const fist2D = this.fistType === 'right' ? points2D[20] : points2D[19]
    if (fist2D.score < 0.6) {
      this.navigations.push({icon: 'warning', text: `${this.fistType === 'right' ? '右腕' : '左腕'}が映る位置`})
    }

    const fist = this.fistType === 'right' ? points[20] : points[19]
    const shoulder = this.fistType === 'right' ? points[12] : points[11]
    if (!this.started) {
      const dist = fist.y - shoulder.y
      if (dist < 0.2) {
        this.navigations.push({icon: 'warning', text: "腕は下ろした位置"})
      }

      if (this.navigations.length === 0) {
        this.started = true
        this.startSE.play()
        this.detector.lastTime = new Date().getTime()
      }
    }
    if (this.navigations.length > 0) {
      return
    }
    // this.debug = (points[20].y - points[12].y).toString().substr(0,4)
    this.detector.mainLoop(fist, shoulder)
  }

  saveData() {
    RecordManager.getInstance().addRecords('dumbbell-curl', {
      'time': 1,
      'continuousCount': 1,
      'count': 1,
    })
  }

  renderCamera(ctx, { pose, hands }) {

  }
}



// WEBPACK FOOTER //
// ./src/components/game/DumbbellCurl.js